import { createApp } from 'vue';
import App from './App.vue';
import router from '../router.ts';
import { createPinia } from 'pinia';
import { DateTime } from 'luxon';
import moment from 'moment';
import 'moment/dist/locale/fr';
import OktaAuth from '@okta/okta-auth-js';
import OktaVue, { useAuth } from '@okta/okta-vue';
import routesConstants from '@/constants/routesConstants.ts';
import axios from 'axios';
import apiErrorHelper from '@/services/apiErrorHelper.ts';
import useErrorsStore from '@/stores/errorStore.ts';
import { vuetify } from '@/vuetify.config.ts';
import 'vuetify/styles';

const app = createApp(App);

const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}${routesConstants.AUTHENTICATION.path}`,
  pkce: false,
});

axios.interceptors.request.use((axiosRequestConfig) => {
  if (axiosRequestConfig.url && axiosRequestConfig.url.indexOf(import.meta.env.VITE_TIME_REPORT_API_BASE_URL) >= 0) {
    const idToken = useAuth().getIdToken();

    if (idToken) {
      axiosRequestConfig.headers.authorization = idToken;
    }
  }

  return axiosRequestConfig;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    apiErrorHelper.handleErrorMessage(error, useErrorsStore());
    Promise.reject(error);
  }
);

moment.locale('fr');

app.use(vuetify);
app.use(router);
app.use(createPinia());
app.use(OktaVue, { oktaAuth });

app.provide('DateTime', DateTime);
app.config.globalProperties.$DateTime = DateTime;

app.mount('#app');
